const eSounds = {
  EST_BACKGROUND: { soundName: 'background', volume: 0.7, group: 'music' },
  EST_BACKGROUND_BONUS: { soundName: 'background_bonus', volume: 0.7, group: 'music' },
  // EST_BIG_WINS_BACKGROUND: { soundName: 'bigWinBG', volume: 0.6, group: 'winning' },
  EST_WIN: { soundName: 'win', volume: 0.8, group: 'winning' },
  EST_WIN_1: { soundName: 'win_1', volume: 0.8, group: 'winning' },
  EST_WIN_2: { soundName: 'win_2', volume: 0.8, group: 'winning' },
  EST_WIN_3: { soundName: 'win_3', volume: 0.8, group: 'winning' },
  EST_WIN_4: { soundName: 'win_4', volume: 0.8, group: 'winning' },
  EST_WIN_5: { soundName: 'win_5', volume: 0.8, group: 'winning' },
  EST_BIG_WIN: { soundName: 'big_win', volume: 0.7, group: 'winning' },
  EST_MEGA_WIN: { soundName: 'mega_win', volume: 0.8, group: 'winning' },
  // EST_EPIC_WIN: { soundName: 'epicWin', volume: 0.7, group: 'winning' },
  EST_MONEY_GAIN: { soundName: 'money_gain', volume: 0.5, group: 'winning' },
  EST_BUTTON_CLICK: { soundName: 'button_click', volume: 1, group: 'default' },
  EST_REEL_STOP: { soundName: 'reel_stop', volume: 0.7, group: 'default' },
  EST_SCATTER_STOP: { soundName: 'bonus_symbol_stop', volume: 1, group: 'default' },
  EST_START_FREESPINS: { soundName: 'bonus_game_start', volume: 0.6, group: 'default' },
  EST_FS_TOTAL_WIN: { soundName: 'bonus_game_end', volume: 0.6, group: 'default' },
  // EST_COIN_FLY: { soundName: 'coinFly', volume: 1, group: 'default' },
  // EST_COLLECT: { soundName: 'collect', volume: 1, group: 'default' },
  EST_REEL_ANTISIPATOR: { soundName: 'antisipator', volume: 0.8, group: 'default' },
  EST_REEL_ANTISIPATOR_TILE: { soundName: 'antisipator_tile', volume: 0.8, group: 'default' },

  EST_OPEN_BOX: { soundName: 'open_box2', volume: 1, group: 'default' },
  EST_WIN_MULTIPLY: { soundName: 'win_multiply', volume: 1, group: 'winning' },
  EST_COIN: { soundName: 'coin', volume: 1, group: 'winning' },
  EST_COOKIE_FAIL: { soundName: 'cookie_fail', volume: 1, group: 'winning' },
  EST_COOKIE_WIN: { soundName: 'cookie_win', volume: 1, group: 'winning' },
  EST_COOKIE_BIG_WIN_1: { soundName: 'cookie_big_win_1', volume: 1, group: 'winning' },
  EST_COOKIE_BIG_WIN_2: { soundName: 'cookie_big_win_2', volume: 1, group: 'winning' },
};

const soundsPreloaderConfig = Object.fromEntries(Object.keys(eSounds).map(key => [key, eSounds[key].soundName]));

export {
  eSounds,
  soundsPreloaderConfig,
}
